<template>
	<ui-modal :iconCircle="true" name="new-integration" icon="fal fa-grip-horizontal">
		<div class="container-modal-new-integrations">
			<div class="container-modal-content">
				<span class="container-modal-content-title">
					Nova Integração de Disponibilidade
				</span>

				<ui-select-v2 v-model="integration"
					:data="integrationOptions"
					label="Deseja integrar com qual ERP?"
					item-label="business_name"
					placeholder="Selecione uma integração"
				/>

				<ui-button :disabled="!integration" design="success xxxl mw-150" @click="next">
					Continuar
				</ui-button>
			</div>
		</div>
	</ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiSelectV2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'

	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'modal-new-integration',

		components: {
			uiModal,
			uiButton,
			uiSelectV2
		},

		data() {
			return {
				integration: null,
			}
		},

		created(){
			this.$root.$on('modal-open-new-integration', () => {
				this.loadIntegrations()
			})

			this.$root.$on('modal-close-new-integration', () => {
				this.integration = null
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-new-integration')
			this.$root.$off('modal-close-new-integration')
		},

		computed: {
			...mapGetters('ERP', {
				integrationOptions: 'getIntegrations',
			}),
		},

		methods: {
			...mapActions('ERP', [
				'loadIntegrations',
				'selectIntegration'
			]),
			/**
			 * Passa para o próximo passo do cadastro de integrações
			 */
			next() {
				this.selectIntegration(this.integration)
				this.$root.$emit('modal-close-new-integration')
			},
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
